module.exports = __webpack_public_path__ + "static/media/sunglasses.ce348477.svg";